export const isUserLoggedIn = () => {
    const token = sessionStorage.getItem("token");
    if (token) {
        // const decryptedData = decryptData(token);
        if (token) {
            return true;
        } else {
            return false;
        }
    }
};

export const truncate = (text, size = 30) => {
    if (!text) return ''; // Handle case where text is undefined or null
    return text.length > size ? text.substring(0, size) + '...' : text;
};